import {useEffect, useState} from "react";
import {getBuyer, getBuyerInvoices} from "../../api/Api";
import {Card, Table, Row, Col} from 'antd';
import {Link, useParams} from "react-router";
import {InvoiceStateWidget} from "../sales/InvoiceStateWidget";

export const BuyerBalanceView = ({refresh, onRefresh, onApiFail, props}) => {
    const params = useParams();
    const {buyerId} = params;
    const [buyer, setBuyer] = useState(undefined);
    const [invoices, setInvoices] = useState([]);
    useEffect(() => {
        if (buyerId === undefined) {
            return;
        }
        getBuyer(buyerId).then(result => {
            setBuyer(result);
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });

        getBuyerInvoices(buyerId).then(result => {
            setInvoices(result.map(r => {
                return {
                    ...r,
                    key: r.id
                }
            }));
        })
    }, [buyerId, refresh, onApiFail]);

    const columns = [
        {
            title: 'Invoice Number',
            dataIndex: 'invoiceNumber',
            key: 'invoiceNumber',
            render: (val, record) => {
                // return <div onClick={selectInvoice(record)} style={{cursor: 'pointer'}}>{val}</div>
                return <Link to={`/invoice/${record.id}`}>{val}</Link>
            },
            sorter: (a, b) => a.invoiceNumber.toLowerCase().localeCompare(b.invoiceNumber.toLowerCase()),
        },
        {
            title: 'Created by',
            dataIndex: 'username',
            key: 'username',
            sorter: (a, b) => a.username.localeCompare(b.username)
        },
        {
            title: 'Date',
            dataIndex: 'timestamp',
            key: 'timestamp',
            render: (val) => {
                const terms = val.split("T");
                return terms[0]
            },
            sorter: (a, b) => (new Date(a.timestamp))- (new Date(b.timestamp)),
        },
        {
            title: 'Status',
            dataIndex: 'state',
            key: 'state',
            render: (val, record, index) => {
                return <InvoiceStateWidget invoice={record} onApiFail={onApiFail} onRefresh={onRefresh} disabled={false}/>
            },
            sorter: (a, b) => a.state - b.state
        },
        {
            title: 'Subtotal',
            dataIndex: 'subtotal',
            key: 'subtotal',
            render: (val) => {
                return `$ ${val}`;
            },
            sorter: (a, b) => a.subtotal - b.subtotal,
        },
        {
            title: 'Paid',
            dataIndex: 'amountPaid',
            key: 'amountPaid',
            sorter: (a, b) => a.amountPaid - b.amountPaid,
        },
        {
            title: 'Balance',
            dataIndex: 'subtotal',
            key: 'balance',
            render: (val, record, index) => {
                const floatVal = record.subtotal - record.amountPaid;
                const fixedVal = floatVal.toFixed(2);
                return `$ ${fixedVal}`
            },
            sorter: (a, b) => {
                const floatValA = a.subtotal - a.amountPaid;
                const floatValB = b.subtotal - b.amountPaid;
                return floatValA - floatValB;
            }
        }
    ];

    let balance = 0;
    let numInvoicesWithBalance = 0;
    invoices.forEach(inv => {
        const floatVal = inv.subtotal - inv.amountPaid;
        balance += floatVal;
        if (floatVal > 0) {
            numInvoicesWithBalance ++;
        }
    });
    balance = balance.toFixed(2);

    const tablePagination = {
        defaultPageSize: 50,
        showSizeChanger: true,
        pageSizeOptions: [50, 100, 150, 200]
    }

    return <div style={{textAlign: 'left'}}>
        {buyer && <Card size={'small'} title={<b>Buyer</b>}>
            <div>{buyer.firstname} {buyer.lastname}</div>
            <div>{buyer.company}</div>
            <div>{buyer.license}</div>
        </Card>
        }
        <Card size={'small'} title={<b>Balances</b>}>
            <Row>
                <Col span={4}>
                    <b>Balance:</b>
                </Col>
                <Col>
                    {`$ ${balance}`}
                </Col>
            </Row>
            <Row>
                <Col span={4}>
                    <b>Invoices with Balance:</b>
                </Col>
                <Col>
                    {`${numInvoicesWithBalance}`}
                </Col>
            </Row>
        </Card>
        <Card size={'small'} title={<b>Invoices</b>}>
            <Table dataSource={invoices} columns={columns} pagination={tablePagination}/>
        </Card>
    </div>
}